var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.290411 0.295384C0.679559 -0.0965109 1.31272 -0.0987375 1.70462 0.290411L7.36499 5.91111C7.55405 6.09884 7.66037 6.35426 7.66037 6.6207C7.66037 6.88713 7.55405 7.14255 7.36499 7.33029L1.70462 12.951C1.31272 13.3401 0.679559 13.3379 0.290411 12.946C-0.0987375 12.5541 -0.0965109 11.921 0.295384 11.5318L5.24116 6.6207L0.295384 1.70959C-0.0965109 1.32044 -0.0987375 0.68728 0.290411 0.295384Z",
    fill: "#323A45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/nextIcon.dbea9c97492927c5bfd13d409acdf732.svg";
export { ForwardRef as ReactComponent };